"use strict";
import React, { useEffect } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { connect, useSelector } from "react-redux";
import RoutesComponent from "./RoutesComponent";
import { changeLanguage } from "i18next";

const mapStateToProps = (state, props) => {
  return {
    ...props,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

const RoutesLink = (props) => {
  const { lang } = useSelector((state) => {
    return {
      lang: state.lang,
    };
  });

  useEffect(() => {
    changeLanguage(lang?.defaultLang);
  }, [lang?.defaultLang]);

  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();

  return (
    <RoutesComponent
      {...props}
      navigate={navigate}
      location={location}
      params={params}
    />
  );
};

export default RoutesLink;
